import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaWhatsapp, FaTelegram, FaViber, FaFacebookMessenger, FaFacebookSquare } from 'react-icons/fa';

import styles from './styles.scss';

export class Share extends React.Component {
    static propTypes = {
        link: PropTypes.string,
        className: PropTypes.string,
    };

    handleShareClick = (e) => {
        e.preventDefault();
        const { target } = e;
        const url = target.href;

        const width = 500;
        const height = 500;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;

        window.open(
            url,
            '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
                width +
                ',height=' +
                height +
                ',top=' +
                top +
                ',left=' +
                left
        );
    };

    render() {
        const { className } = this.props;
        let shareLinks;

        if (window.outerWidth < 768) {
            shareLinks = {
                whatsapp: {
                    title: 'WhatsApp',
                    icon: <FaWhatsapp size={20} />,
                    style: styles.whatsapp,
                    link: `whatsapp://send?text=${this.props.link}`,
                },
                telegram: {
                    title: 'Telegram',
                    icon: <FaTelegram size={20} />,
                    style: styles.telegram,
                    link: `tg://msg?text=${this.props.link}`,
                },
                viber: {
                    title: 'Viber',
                    icon: <FaViber size={20} />,
                    style: styles.viber,
                    link: `viber://forward?text=${this.props.link}`,
                },
                messenger: {
                    title: 'Messenger',
                    icon: <FaFacebookMessenger size={20} />,
                    style: styles.messenger,
                    link: `fb-messenger://share/?link=${this.props.link}`,
                },
                facebook: {
                    title: 'Share on Facebook',
                    icon: <FaFacebookSquare size={20} />,
                    style: styles.facebook,
                    link: `https://www.facebook.com/sharer/sharer.php?u=${this.props.link}`,
                },
            };
        } else {
            shareLinks = {
                whatsapp: {
                    title: 'WhatsApp',
                    icon: <FaWhatsapp size={20} />,
                    style: styles.whatsapp,
                    link: `https://web.whatsapp.com/send?text=${this.props.link}`,
                },
                telegram: {
                    title: 'Telegram',
                    icon: <FaTelegram size={20} />,
                    style: styles.telegram,
                    link: `https://telegram.me/share/url?url=${this.props.link}`,
                },
                facebook: {
                    title: 'Share on Facebook',
                    icon: <FaFacebookSquare size={20} />,
                    style: styles.facebook,
                    link: `https://www.facebook.com/sharer/sharer.php?u=${this.props.link}`,
                },
            };
        }

        return (
            <ul className={classNames(styles.root, className)}>
                {Object.keys(shareLinks).map((item, key) => (
                    <li key={key}>
                        <a
                            onClick={this.handleShareClick}
                            className={shareLinks[item].style}
                            href={shareLinks[item].link}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-link="share-product"
                            data-name={shareLinks[item].title}
                        >
                            {shareLinks[item].icon}
                            {shareLinks[item].title}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }
}
